/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["teo-KE",[["Taparachu","Ebongi"],u,u],u,[["J","B","A","U","U","K","S"],["Jum","Bar","Aar","Uni","Ung","Kan","Sab"],["Nakaejuma","Nakaebarasa","Nakaare","Nakauni","Nakaung’on","Nakakany","Nakasabiti"],["Jum","Bar","Aar","Uni","Ung","Kan","Sab"]],u,[["R","M","K","D","M","M","J","P","S","T","L","P"],["Rar","Muk","Kwa","Dun","Mar","Mod","Jol","Ped","Sok","Tib","Lab","Poo"],["Orara","Omuk","Okwamg’","Odung’el","Omaruk","Omodok’king’ol","Ojola","Opedel","Osokosokoma","Otibar","Olabor","Opoo"]],u,[["KK","BK"],u,["Kabla ya Christo","Baada ya Christo"]],0,[6,0],["dd/MM/y","d MMM y","d MMMM y","EEEE, d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"KES","Ksh","Ango’otol lok’ Kenya",{"JPY":["JP¥","¥"],"KES":["Ksh"],"UGX":["USh"],"USD":["US$","$"]},"ltr", plural];
